import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-stats-data-item',
  templateUrl: './stats-data-item.component.html',
  styleUrls: ['./stats-data-item.component.scss']
})

export class StatsDataItemComponent {
  @Input() item: any;
  @Input() eventId: any;
  @Input() iAmAdmin: boolean;

  @Output() transactionDetailsRequested = new EventEmitter<string>();

  constructor(
    private auth: AuthenticationService,
    private http: HttpClient
  ) {}

  downloadFile(fileUrl, fileName) {
    const token = this.auth.currentUserValue.accessToken;
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    this.http.get(fileUrl, { headers, responseType: 'blob' }).subscribe((response) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  /**
   * Emite el hash de la transacción para que el componente padre pueda gestionarlo.
   * @param hash El hash de la transacción del pedido de plataforma.
   */
  public requestTransactionDetails(hash: string): void {
    if (!hash.trim()) {
      console.log('StatsDataItemComponent.requestTransactionDetails: No hash provided');
      return;
    }

    this.transactionDetailsRequested.emit(hash);
  }
}
